import React from 'react';
import './App.css';

import Dashboard from './components/Dashboard';
import ProductDirectory from './components/product-directory/ProductDirectory';
import ProjectsCard from './components/ProjectsCard';
import ProjectDetails from './components/ProjectDetails';
import { Routes, Route } from 'react-router-dom';
import Dmp from './components/Dmp';
import ContributorTestimonial from './components/contributor_testimonials/contributortestimonials';
import Angelmentortestimonials from './components/angel_mentors/angelementortestimonials';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* <Route path="/" element={<Dmp />} /> */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<ProjectsCard />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route path="/dmp-a" element={<Dmp />} />
        <Route path="/product-directory" element={<ProductDirectory />} />
        <Route path="/contributor-testimonials" element={<ContributorTestimonial />} />
        <Route path='/angel-mentor-testimonials' element={<Angelmentortestimonials />} />
      </Routes>
    </div>
  );
}

export default App;